var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('core-details-page', {
    attrs: {
      "fetch-item": _vm.fetchItem,
      "external-fetch-params": {
        itemId: _vm.itemId
      },
      "headline": _vm.headline,
      "subtitle": _vm.subtitle,
      "tabs": _vm.tabs,
      "isFormValid": _vm.formValidCompute,
      "edit-mode": _vm.isDeviceTemplateManager,
      "parent-href": "/device-templates",
      "save-item": _vm.saveItem,
      "templateInformation": _vm.templateInformation
    },
    on: {
      "item-change-state": newState => _vm.templateInformation.templateIsChanged = newState
    },
    scopedSlots: _vm._u([{
      key: "deviceMetaInformation",
      fn: function (slotProps) {
        return [_c('core-device-template-edit-device-information', {
          attrs: {
            "template": slotProps.item,
            "isProductiveVersion": slotProps.item.isProductiveVersion,
            "account": _vm.account,
            "readonly": !_vm.isDeviceTemplateManager
          },
          on: {
            "formValidated": _vm.handleDeviceMetaFormValidated
          },
          model: {
            value: slotProps.item,
            callback: function ($$v) {
              _vm.$set(slotProps, "item", $$v);
            },
            expression: "slotProps.item"
          }
        })];
      }
    }, {
      key: "templateMetaInformation",
      fn: function (slotProps) {
        return [_c('core-device-template-edit-template-information', {
          attrs: {
            "template": slotProps.item,
            "isProductiveVersion": slotProps.item.isProductiveVersion,
            "account": _vm.account,
            "readonly": !_vm.isDeviceTemplateManager
          },
          on: {
            "formValidated": _vm.handleTemplateMetaFormValidated
          },
          model: {
            value: slotProps.item,
            callback: function ($$v) {
              _vm.$set(slotProps, "item", $$v);
            },
            expression: "slotProps.item"
          }
        })];
      }
    }, {
      key: "dataStates",
      fn: function (slotProps) {
        return [_c('core-device-template-data-states', {
          attrs: {
            "template": slotProps.item,
            "isProductiveVersion": slotProps.item.isProductiveVersion,
            "account": _vm.account,
            "readonly": !_vm.isDeviceTemplateManager,
            "templateInformation": _vm.templateInformation
          },
          on: {
            "formValidated": _vm.handleDataStatesFormValidated,
            "update-unsaved-changes": _vm.updateUnsavedChanges
          },
          model: {
            value: slotProps.item,
            callback: function ($$v) {
              _vm.$set(slotProps, "item", $$v);
            },
            expression: "slotProps.item"
          }
        })];
      }
    }, {
      key: "ruleEditor",
      fn: function (slotProps) {
        return [_c('core-device-template-rule-editor', {
          attrs: {
            "template": slotProps.item,
            "readonly": !_vm.isDeviceTemplateManager,
            "isProductiveVersion": slotProps.item.isProductiveVersion
          },
          on: {
            "update-unsaved-changes": _vm.updateUnsavedChanges
          },
          model: {
            value: slotProps.item,
            callback: function ($$v) {
              _vm.$set(slotProps, "item", $$v);
            },
            expression: "slotProps.item"
          }
        })];
      }
    }, {
      key: "dataRouting",
      fn: function (slotProps) {
        return [_c('core-device-template-data-routing', {
          attrs: {
            "template": slotProps.item,
            "readonly": !_vm.isDeviceTemplateManager,
            "isProductiveVersion": slotProps.item.isProductiveVersion
          },
          model: {
            value: slotProps.item,
            callback: function ($$v) {
              _vm.$set(slotProps, "item", $$v);
            },
            expression: "slotProps.item"
          }
        })];
      }
    }, {
      key: "linkedDevices",
      fn: function () {
        return [_c('core-virtual-device-list', {
          attrs: {
            "searchTypes": _vm.searchTypes,
            "predefined-search": _vm.linkedDevicesPredefinedSearch,
            "favourite-filter-enabled": false,
            "restoreFilter": false
          },
          on: {
            "load-items": _vm.setLinkedDevicesTotalCountItems
          }
        })];
      },
      proxy: true
    }, {
      key: "unsyncedChanges",
      fn: function (slotProps) {
        return [_c('core-device-template-unsynced-changes', {
          attrs: {
            "template": slotProps.item,
            "linkedDevicesTotalCount": _vm.templateInformation.linkedDevicesTotalCount,
            "hasUnsavedChanges": _vm.templateInformation.templateIsChanged,
            "unsyncedChanges": _vm.templateInformation.unsyncedChanges,
            "readonly": !_vm.isDeviceTemplateManager
          },
          on: {
            "save-and-synchronise": _vm.updateUnsyncedChanges
          }
        })];
      }
    }, {
      key: "healthStateExpertModeMetricCodeEditor",
      fn: function (slotProps) {
        return [_c('code', [_vm._v("function (params) {")]), _c('codemirror', {
          staticClass: "elevation-3",
          attrs: {
            "value": _vm.get(slotProps.item, slotProps.field.key),
            "options": {
              ..._vm.cmOptions,
              readOnly: !_vm.isDeviceTemplateManager
            }
          },
          on: {
            "input": slotProps.emitInput
          }
        }), _c('code', [_vm._v("}")])];
      }
    }])
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };